import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CookieBanner from '../components/CookieBanner';

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header onSubscribeClick={() => {}} />
      
      <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <h1 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-4">
          Terms of Service
        </h1>
        <p className="text-sm text-neutral-500 mb-12">
          Last updated: January 20, 2026
        </p>

        <div className="prose prose-lg max-w-none space-y-8 text-neutral-700">
          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using Artinent.com, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these terms, please do not use our website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">2. Use License</h2>
            <p>
              Permission is granted to temporarily access the materials on Artinent.com for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to reverse engineer any software contained on the website</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">3. Disclaimer</h2>
            <p>
              The materials on Artinent.com are provided on an 'as is' basis. Artinent.com makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">4. Limitations</h2>
            <p>
              In no event shall Artinent.com or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Artinent.com, even if Artinent.com or an authorized representative has been notified orally or in writing of the possibility of such damage.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">5. Accuracy of Materials</h2>
            <p>
              The materials appearing on Artinent.com could include technical, typographical, or photographic errors. Artinent.com does not warrant that any of the materials on its website are accurate, complete, or current. Artinent.com may make changes to the materials contained on its website at any time without notice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">6. Links</h2>
            <p>
              Artinent.com has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Artinent.com. Use of any such linked website is at the user's own risk.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">7. Modifications</h2>
            <p>
              Artinent.com may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">8. Governing Law</h2>
            <p>
              These terms and conditions are governed by and construed in accordance with the laws of Australia and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">9. User Content</h2>
            <p>
              If you submit content to our website, you grant Artinent.com a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and distribute such content. You represent and warrant that you own or have the necessary rights to grant this license.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">10. Contact Information</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us:
            </p>
            <p className="mt-4">
              News Pty Limited<br />
              ACN: 007 871 187 | ABN: 47 007 871 187<br />
              Email: legal@Artinent.com<br />
              Address: 2 Holt Street, Surry Hills NSW 2010, Australia<br />
              Phone: +61 2 9288 3000
            </p>
          </section>
        </div>
      </main>

      <Footer />
      <CookieBanner />
    </div>
  );
};

export default Terms;
